import axios from 'axios';

const axiosBlobErrorInterceptor = (error) => {
  if (error.request.responseType === 'blob'
    && error.response.data instanceof Blob
    && error.response.data.type
    && error.response.data.type === 'application/json') {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        error.response.data = JSON.parse(reader.result);
        resolve(Promise.reject(error));
      };

      reader.onerror = () => {
        reject(error);
      };

      reader.readAsText(error.response.data);
    });
  }

  return Promise.reject(error);
};

/**
 * Create an axios instance for the "blob" response type.
 *
 * Includes a custom interceptor to enable json response on error.
 *
 * @return {AxiosInstance}
 */
const createAxiosBlobClient = () => {
  const client = axios.create({
    responseType: 'blob'
  });

  client.interceptors.response.use(
    (response) => response,
    axiosBlobErrorInterceptor,
  );

  return client;
};

const axiosBlobClient = createAxiosBlobClient();

export { axiosBlobClient, axiosBlobErrorInterceptor };
